import { Data } from '@angular/router';

export class DsUserFront {
  /**
   * Account id
   */
  accountId: number;

  /**
   * Account lid
   */
  accountLid: string;

  /**
   * Account firstname
   */
  accountFirstName: string;

  /**
   * Account lastname
   */
  accountLastName: string;

  /**
   * Account email
   */
  accountEmail: string;

  /**
   *
   */
  accountLangue?: string;

  /**
   *
   */
  sxdAdmin: number;

  /**
   *
   */
  isDirector?: boolean;

  /**
   *
   */
  projects?: Data[];

  /**
   *
   */
  accountPhonenumber?: string;

  /**
   *
   */
  isReferent?: boolean;

  /**
   *
   */
  companies?: Data[];

  /**
   *
   */
  groups?: Data[];

  /**
   * User.
   *
   * @param jsonData User account.
   */
  constructor(jsonData?: Data) {
    if (!jsonData.isNew) this.accountId = jsonData.account_id || jsonData.accountId || this.accountId;
    this.accountLid = jsonData.account_lid || jsonData.accountLid || this.accountLid;
    this.accountFirstName = jsonData.account_firstname || jsonData.accountFirstName || this.accountFirstName;
    this.accountLastName = jsonData.account_lastname || jsonData.accountLastName || this.accountLastName;
    this.accountEmail = jsonData.account_email || jsonData.accountEmail || this.accountEmail;
    this.accountLangue = jsonData.account_langue || this.accountLangue;
    this.sxdAdmin = jsonData.sxd_admin || this.sxdAdmin;
    this.isDirector = jsonData.isDirector || this.isDirector;
    this.projects = jsonData.projects || this.projects;
    this.accountPhonenumber = jsonData.account_phonenumber || jsonData.accountPhonenumber || this.accountPhonenumber;
    this.isReferent = jsonData.is_referent || this.isReferent;
    this.companies = jsonData.companies || this.companies;
    this.groups = jsonData.groups || this.groups;
  }
}
